function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import { useCallback, useEffect, useState } from 'react';
import * as QueryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
const api = buildService('/lists/claim_groups/{id}/claim_project_reports', {
  only: ['all']
});
const claimProjectReportsListsService = {
  base: api,
  useFetchProjects: claimGroupId => {
    const getAll = useErrorHandling(useCallback(async params => {
      const response = await api.all(claimGroupId, params);
      return response;
    }, [claimGroupId]));
    return [getAll];
  },
  useFetchAll: _ref => {
    let {
      accountType,
      claimGroupId,
      initialQueryParams = '',
      setLoading,
      groupProjects = false,
      fetchImmediatelly = true,
      updateUrl = true,
      usePageFromUrl = true
    } = _ref;
    const history = useHistory();
    const location = useLocation();
    const [projects, setProjects] = useState([]);
    const [totalPages, setTotalPages] = useState(null);
    const [totalCostSum, setTotalCostSum] = useState(null);
    const [totalQeSum, setTotalQeSum] = useState(null);
    const [queryParams, setQueryParams] = useState(() => {
      const parsed = _objectSpread(_objectSpread({}, QueryString.parse(location.search || initialQueryParams)), {}, {
        group_projects: groupProjects
      });
      if (!usePageFromUrl) delete parsed.page;
      return parsed;
    });
    const fetchAllProjetcs = useErrorHandling(useCallback(async queryParams => {
      var _Object$fromEntries;
      setLoading && setLoading(true);
      const projects = await api.all(claimGroupId, queryParams);
      setTotalPages(projects.pages);
      setProjects(projects.claim_project_reports);
      setTotalCostSum(projects.total_cost_sum);
      setTotalQeSum(projects.total_qe_sum);

      // when it is at document level it sometimes push history which makes folder management to make a false call to api without id and model in url params
      // this happens when the above service call is slightly delayed and user nabigates to project > document tab quickly. 
      if (((_Object$fromEntries = Object.fromEntries(new URL(window.location).searchParams)) === null || _Object$fromEntries === void 0 ? void 0 : _Object$fromEntries.key) !== 'documents' && updateUrl) {
        history.push({
          path: "".concat(accountType, "/claims"),
          search: QueryString.stringify(queryParams)
        });
      }
      return projects;
    }, [accountType, claimGroupId, history, setLoading, updateUrl]), useCallback(() => {
      setLoading && setLoading(false);
    }, [setLoading]));
    useEffect(() => {
      if (fetchImmediatelly) {
        claimGroupId && fetchAllProjetcs(queryParams);
      }
    }, [fetchAllProjetcs, queryParams, claimGroupId, fetchImmediatelly]);
    return [projects, setProjects, totalPages, setTotalPages, queryParams, setQueryParams, fetchAllProjetcs, totalCostSum, totalQeSum];
  }
};
export default claimProjectReportsListsService;